<template>
    <section class="attachment-viewer-modal esesja-modal" @keyup="keyPressed" @wheel="wheeled" ref="modal" tabindex="0">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__body attachment-viewer">
                <section class="attachment-viewer--header">
                    <button class="esesja-modal__wraper__header__exit-btn" @click="closeModal" style="background:#fff">
                        <img src="../../../../../assets/icons/components/exit-btn.svg" />
                    </button>
                </section>
                <section class="attachment-viewer--body">
                    <section class="attachment-viewer--body--prev">
                        <button class="attachment-viewer--button attachment-viewer--button--small" v-if="fileType.isPfd" @click="prevPage" :disabled="isBusy">
                            <img src="../../../../../assets/icons/panel/editSession/arrow-left.svg" />
                        </button>
                    </section>
                    <section class="attachment-viewer--body--content">
                        <section class="scale-buttons" v-if="fileType.isPfd">
                            <section style="display: flex; align-items: baseline;">
                                <button class="attachment-viewer--button attachment-viewer--button--small" @click="scaleUp" :disabled="isBusy" style="margin-right: 2px;">+</button>
                                 {{ scale }}% 
                                <button class="attachment-viewer--button attachment-viewer--button--small" @click="scaleDown" :disabled="isBusy">-</button>
                            </section>
                        </section>
                        <VuePDF :id="pdfFIle" :pdf="fileBlob" :page="page" :scale="(scale/100)" v-if="fileType.isPfd" @loaded="() => isBusy = false" />
                        <img :src="imageData" v-else-if="fileType.isImage"/>
                        <textarea v-else-if="fileType.isText" v-model="textData" style="height:80vh; width: 30vw;"></textarea>
                    </section>
                    <section class="attachment-viewer--body--next">
                        <button class="attachment-viewer--button attachment-viewer--button--small" v-if="fileType.isPfd" @click="nextPage" :disabled="isBusy">
                            <img src="../../../../../assets/icons/panel/editSession/arrow-left.svg" style="transform: rotate(180deg);" />
                        </button>
                    </section>
                </section>
                <section class="attachment-viewer--footer">
                    <section class="left"></section>
                    <section class="center"  style="margin-right: -20px">
                        <span v-if="fileType.isPfd">
                            Strona {{page}} z {{maxPages}}
                        </span>
                    </section>
                    <section class="right">
                        <button class="attachment-viewer--button" style="margin-right:20px;" @click="download">Pobierz</button>
                    </section>
                </section>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import { VuePDF, usePDF } from '@tato30/vue-pdf'
    import esesjaInteractiveService from '../../../../../services/esesja.interactive.service';
    import alertsHelper from '../../../../../helpers/alerts.helper';
    
    export default {
        name: "AttachmentViewer",
        emits: ["close"],
        components: {
            VuePDF,
        },
        props: {
            title: {
                type: String,
                default: 'Przeglądarka załączników'
            },
            pointId: {
                type: Number,
                required: true
            },
            attachmentId: {
                type: Number,
                required: true
            },
            fileData: {
                type: Object,
                require: true
            },
            filename: {
                type: String,
                require: true,
            },
            sessionId: {
                type: Number,
                require: true,
            }

        },
        data() {
            return {
                page: 1,
                maxPages: 1,

                fileBlob: undefined,
                imageData: undefined,
                textData: undefined,
                fileType: {
                    isPfd: false,
                    isImage: false,
                    isText: false,
                },
                scale: 100,
                pdfFIle: this.attachmentId,
                isBusy: false,
            }
        },
        computed: {
            isInteractive() {
                return this.$store.state.appStore.isInInteractiveMode;
            },
        },
        async mounted() {
            if (this.pointId === -1) {
                return;
            }

            if (this.attachmentId === -1) {
                return;
            }

            this.$refs.modal.focus();

            await this.prepareFile();
        },
        methods: {
            async closeModal() {
                let urlCreator = window.URL || window.webkitURL;
                if (this.fileType.isPfd) {
                    this.fileBlob.destroy();
                    urlCreator.revokeObjectURL(this.fileBlob);
                    this.scale = 1;
                    this.page = 1;
                    this.fileBlob = undefined;
                }
                else if (this.fileType.isImage) {
                    urlCreator.revokeObjectURL(this.imageData)
                }
                this.fileType.isPfd = false;
                this.fileType.isImage = false;
                this.fileType.isText = false;

                this.$emit('close')
            },

            async prepareFile() {
                try {

                    if (this.fileData.headers['content-type'] === 'application/pdf') {
                        this.fileType.isPfd = true;
                        this.fileType.isImage = false;
                        this.fileType.isText = false;
                    }
                    else if (this.fileData.headers['content-type'].startsWith("image/"))
                    {
                        this.fileType.isPfd = false;
                        this.fileType.isImage = true;
                        this.fileType.isText = false;
                    }
                    else if (this.fileData.headers['content-type'].startsWith("text/plain")) {
                        this.fileType.isPfd = false;
                        this.fileType.isImage = false;
                        this.fileType.isText = true;
                    }

                    if (this.fileType.isPfd) {
                        const { pdf, pages } = await usePDF(this.copy(this.fileData.data));
                        this.fileBlob = pdf;
                        this.maxPages = pages;
                    }
                    else if (this.fileType.isImage) {
                        let blob = new Blob([this.copy(this.fileData.data)], { type: this.fileData.headers['content-type'] });
                        let urlCreator = window.URL || window.webkitURL;
                        this.imageData = urlCreator.createObjectURL(blob);
                    }
                    else if (this.fileType.isText) {
                        let blob = new Blob([this.copy(this.fileData.data)], { type: this.fileData.headers['content-type'] });
                        this.textData = await blob.text()
                    }
                }
                catch (e) {
                    console.log("Bład pdf", e);
                }
                finally {
                    this.$store.commit('hideLoader');
                }
            },

            prevPage() {
                if (this.isBusy === true) {
                    return;
                }

                if (this.page <= 1) {
                    return;
                }
                this.isBusy = true;
                this.page--;
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, this.page, this.scale);
                }
            },

            nextPage() {
                if (this.isBusy === true) {
                    return;
                }

                if (this.page >= this.maxPages) {
                    return;
                }
                this.isBusy = true;
                this.page++;
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, this.page, this.scale);
                }
            },

            scaleUp() {
                if (this.isBusy === true) {
                    return;
                }
                this.isBusy = true;
                this.scale += 1;
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, this.page, this.scale);
                }
            },

            scaleDown() {
                if (this.isBusy === true) {
                    return;
                }

                this.isBusy = true;
                this.scale -= 1;

                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, this.page, this.scale);
                }
            },

            keyPressed(e) {

                if (!e.isTrusted) {
                    return;
                }

                if (e.key === undefined) {
                    return;
                }

                if (e.keyCode === undefined) {
                    return;
                }

                if (this.isBusy === true) {
                    return;
                }

                e.preventDefault();

                switch (e.keyCode) {
                    case 33: //page up
                    case 37: this.prevPage(); break; //arrow left;
                    case 34: //page down
                    case 39: this.nextPage(); break; //arrow right
                    case 36: this.page = 1; this.isBusy = true; break; // home
                    case 27: this.closeModal(); // escape
                }
            },

            wheeled(e) {
                if (!this.fileType.isPfd) {
                    return;
                }

                if (this.isBusy === true) {
                    return;
                }

                if (e.deltaY > 0) {
                    this.nextPage();
                }
                else {
                    this.prevPage();
                }
            },

            async download() {
                try {
                    var a = document.createElement('a');
                    var blob = new Blob([this.fileData.data], { 'type': this.fileData.headers['content-type'] });

                    a.href = window.URL.createObjectURL(blob);
                    a.download = this.filename;
                    a.click();
                }
                catch {
                    var errorAlert = this.$swal.mixin(alertsHelper.errorToastElement());
                    errorAlert.fire(alertsHelper.errorToastAlert('Nie można pobrać pliku'));
                }
            },
            copy(src) {
                var dst = new ArrayBuffer(src.byteLength);
                new Uint8Array(dst).set(new Uint8Array(src));
                return dst;
            }
        }
    }
</script>
<style lang="scss" scope>
    @import "../../../../../assets/scss/esesja-modal.scss";

    .scale-buttons {
        display: flex;
        align-items: baseline;
        justify-content: space-around;
    }

    /*.attachment-viewer-modal .esesja-modal__wraper {
        max-width: 1200px;
    }

    .attachment-viewer-modal .esesja-modal__wraper__body {
        max-height: 100vh;
        padding: 0px;
    }

    .attachment-viewer {
        display: flex;
        flex-direction: column;

        &--header {
            display: flex;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }

        &--body {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        &--footer {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        &--button {
            
            height: 32px;
            margin-left: 8px;
            background-color: white;
            border: 1px solid #bbc2ce;
            box-sizing: border-box;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease-in-out;

            &--small{
                width: 30px;
            }

            img {
                width: 2.2em
            }

            &:hover {
                background-color: #e8ebef;
            }

        }
    }*/
</style>